import { Component } from "@angular/core";
import { BaseInsuranceComponent } from "../base/base.component";
import { NxAccordionModule } from "@aposin/ng-aquila/accordion";
import { ResultItemComponent } from "../../result-item/result-item.component";
import { TranslationComponent } from "../../translation/translation.component";

@Component({
  selector: "app-material-insurance",
  standalone: true,
  imports: [NxAccordionModule, ResultItemComponent, TranslationComponent],
  templateUrl: "./material-insurance.component.html",
  styleUrl: "./material-insurance.component.css",
})
export class MaterialInsuranceComponent extends BaseInsuranceComponent {}
